import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ToastType = 'success' | 'error';

type Toast = {
  id: string; // unique ID
  message: string;
  type: ToastType;
};

type ToastState = {
  toasts: Toast[];
};

const initialState: ToastState = {
  toasts: [],
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    addToast: (state, action: PayloadAction<Omit<Toast, 'id'>>) => {
      const { message, type } = action.payload;

      if (!Array.isArray(state.toasts)) {
        state.toasts = []; // Initialize as an empty array
      }

      const id = crypto.randomUUID();
      state.toasts.push({ id, message, type });
    },
    removeToast: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter(
        (toast) => toast.id !== action.payload
      );
    },
  },
});

export const { addToast, removeToast } = toastSlice.actions;
export default toastSlice.reducer;
